<script lang="ts">
    import {TwoSplit} from 'src/features/erp/components';
    import type {UIcons} from 'shared/ui-widgets/uicons/types';
    import {exists} from 'shared/utils/custom-utils';
    import ErpHeadingBar from '../ErpHeadingBar.svelte';
    import ErpPageLayout from '../ErpPageLayout.svelte';

    export let orientation: 'horizontal' | 'vertical';
    export let pageClass: string;
    export let ratios: [number, number] = [1, 1];
    export let withoutPanelPadding = false;
    export let withoutScroll = false;
    export let withoutLogo = false;
    export let resizeDisabled = false;
    export let headingIcon: UIcons | null = null;
</script>

<ErpPageLayout {pageClass} {withoutLogo} withoutContentPadding gap="0">
    {#if exists($$slots.heading)}
        <ErpHeadingBar slot="heading" icon={headingIcon}>
            <slot name="heading"/>
        </ErpHeadingBar>
    {/if}

    {#if exists($$slots.topbar)}
        <slot name="topbar"/>
    {/if}

    <TwoSplit {orientation}
              {ratios}
              {withoutPanelPadding}
              {withoutScroll}
              {resizeDisabled}
              persistentStorageKeyPrefix={pageClass}>

        <slot name="first-panel" slot="first-panel"/>
        <slot name="second-panel" slot="second-panel"/>
    </TwoSplit>
</ErpPageLayout>